import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { TablePaginationActionsProps } from '@material-ui/core/TablePagination/TablePaginationActions'
import IconButton from '@material-ui/core/IconButton'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LastPageIcon from '@material-ui/icons/LastPage'
import TablePagination, { TablePaginationProps } from '@material-ui/core/TablePagination'

const useActionsClasses = makeStyles((theme: Theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}))

const TablePaginationActions = (props: TablePaginationActionsProps) => {
  const classes = useActionsClasses()
  const { count, page, rowsPerPage, onPageChange } = props

  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0)
  }

  const handleBackButtonClick = event => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = event => {
    onPageChange(event, page + 1)
  }

  const handleLastPageButtonClick = event => {
    onPageChange(event, count >= 0 ? Math.max(0, Math.ceil(count / rowsPerPage) - 1) : -1)
  }

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={count >= 0 && page >= Math.ceil(count / rowsPerPage) - 1}
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={count >= 0 && page >= Math.ceil(count / rowsPerPage) - 1}
      >
        <LastPageIcon />
      </IconButton>
    </div>
  )
}

const ListTablePagination = (props: TablePaginationProps<'div'>) => {
  const { t } = useTranslation()

  return <div>
    <TablePagination
      component="div"
      rowsPerPageOptions={[20, 50, 100]}
      labelRowsPerPage={`${t('show')}:`}
      labelDisplayedRows={({ from, to, count }) => `${from}-${to === -1 ? count : to} / ${count !== -1 ? count : '...'}`}
      ActionsComponent={TablePaginationActions}
      {...props}
    />
  </div>
}

export default ListTablePagination
